import { firebaseReducer } from 'react-redux-firebase';

export default firebaseReducer;
